<template>
  <v-flex xs6 sm1 md1>
    <div class="caption grey--text">
      Upload
    </div>
    <div>
      {{ torrent.upspeed | getDataValue(1) }}
      <span class="caption grey--text">
        {{
          torrent.upspeed | getDataUnit(1)
        }}/s
      </span>
    </div>
  </v-flex>
</template>
<script>
export default {
  name: 'Upload',
  props: ['torrent']
}
</script>
